<template>
   <div class="create-assessment width margin-left-3Perc margin-top-2Point5Perc container-fluid lesson-box-border" @keydown.esc="performCloseOperation"> 
        <div class="overflow-hidden">
            <div class="row padding-Top-2Perc vertical-align text-align-left">
              <div class="col-md-12 col-lg-12">
                Showing results for:
              </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 font-color-blue font-size-21px text-align-left font-weight-bold margin-bottom-2Perc">{{this.$store.state.selectedAssessmentObjFromFilter.AssessmentTitle}} {{this.$store.state.selectedAssessmentObjFromFilter.AssessmentSubTitle === null || this.$store.state.selectedAssessmentObjFromFilter.AssessmentSubTitle === '' || this.$store.state.selectedAssessmentObjFromFilter.AssessmentSubTitle === undefined ? '' : '[' + this.$store.state.selectedAssessmentObjFromFilter.AssessmentSubTitle + ']'}}
                </div>  
            </div>    
            <hr/>
             <div class="row overflow-y-hidden center-align-div">
                <div class="col-md-12 col-lg-12 overflow-y-hidden margin-bottom-2Perc">
                  <draggable :elementListValue="elementListValue" v-model="elementListValue">
                    <transition-group>
                      <assessment-element-list v-for="eleObj in elementListValue" :key="eleObj.ElementId" v-bind:ElementObj="eleObj"></assessment-element-list>
                    </transition-group>
                  </draggable>
                </div>
                <assessment-element-list-create-element-option></assessment-element-list-create-element-option>   
            </div>    
        </div>
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="onUserConfirmation"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div> 
</template>
<script>
import draggable from 'vuedraggable'
import Loader from '@/components/dashboard/Loader'
import { elementService } from '@/server-util/element-service'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { constants } from '@/utils/constants'
import AssessmentElementList from '@/components/assessment_journey/AssessmentElementList'
import AssessmentCreateElementOption from '@/components/assessment_journey/AssessmentCreateElementOption'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
//  import qs from 'qs'
export default {
  name: 'create-assessment',
  created () {
    this.setDefaultValue()
  },
  mounted: function () {
    this.eventHub.$on('ElementListUpdated', updatedList => {
      this.$store.state.selectedAssessmentElementList = []
      setTimeout(() => {
        this.$store.state.selectedAssessmentElementList = updatedList
        this.elementObjList = updatedList
      }, 50)
    })
  },
  beforeDestroy: function () {
    this.eventHub.$off('ElementListUpdated')
  },
  data: function () {
    return {
      elementObjList: [],
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      title_maxLength: constants.Lesson_Title_Max_Length,
      reIndexedObj: {
        AssessmentId: '',
        StepList: []
      }
    }
  },
  components: {
    'assessment-element-list': AssessmentElementList,
    'assessment-element-list-create-element-option': AssessmentCreateElementOption,
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    draggable
  },
  methods: {
    onUserConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        switch (this.prefixString) {
          default:
          case 'Are you sure you want to re-order it':
            this.reIndexedObj.StepList = []
            console.log(JSON.stringify(this.getSelectedAssessmentObj))
            this.reIndexedObj.AssessmentId = this.getSelectedAssessmentObj.AssessmentId
            var minElementIndex = this.getSelectedAssessmentObj.MinElementIndex !== undefined && this.getSelectedAssessmentObj.MinElementIndex !== 'undefined' && this.getSelectedAssessmentObj.MinElementIndex !== null && this.getSelectedAssessmentObj.MinElementIndex !== 'null' && this.getSelectedAssessmentObj.MinElementIndex !== '' ? this.getSelectedAssessmentObj.MinElementIndex : 0

            for (var i = 0; i < this.elementObjList.length; i++) {
              // AK: create Object initially
              var elementObj = {
                ElementId: this.elementObjList[i].ElementId,
                Type: this.elementObjList[i].Type,
                Title: this.elementObjList[i].Title,
                OldIndex: 0,
                NewIndex: 0
              }
              // AK: For very first element object, use minIndex and later on increase it by one
              if (i !== 0) {
                minElementIndex += 1
              }
              elementObj.OldIndex = parseInt(this.elementObjList[i].Index)
              elementObj.NewIndex = parseInt(minElementIndex)
              this.reIndexedObj.StepList.push(elementObj)
            }
            console.log(JSON.stringify(this.reIndexedObj))
            this.performReIndexingOperation()
            break
        }
      }
    },
    performReIndexingOperation: function () {
      var storeObj = this.$store
      if (
        this.reIndexedObj.AssessmentId !== undefined &&
        this.reIndexedObj.AssessmentId !== ''
      ) {
        // _this.showSpinner = true
        this.$store.state.isLoading = true
        elementService
          .reIndexAssessmentElements(storeObj.state.access_token, this.reIndexedObj)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.reIndexedObj.StepList = []
              this.elementObjList = responseObj.data
              this.$store.state.selectedAssessmentElementList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.setDefaultValue()
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            this.setDefaultValue()
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.setDefaultValue()
        console.log(
          'Selected COURSEMASTERID is NULL hence declined RE-INDEXING ASSESSMENT OPERATION'
        )
      }
    },
    performCloseOperation: function () {},
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of swipe confirmation overlay
      this.showConfirmationBox = value
      // AK: Reset list back to original state
      this.setDefaultValue()
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    setDefaultValue: function () {
      this.elementObjList = this.$store.state.selectedAssessmentElementList
    }
  },
  computed: {
    getSelectedAssessmentObj: {
      get: function () {
        return this.$store.state.selectedAssessmentObjFromFilter
      }
    },
    elementList () {
      return this.$store.state.selectedAssessmentElementList
    },
    elementListValue: {
      get: function () {
        return this.elementObjList
      },
      set: function (newValue) {
        this.showConfirmationBox = true
        this.prefixString = 'Are you sure you want to re-order it'
        this.postString = '?'
        this.elementObjList = newValue
        // console.log('Re-arranged List >>>> ' + JSON.stringify(this.elementObjList))
      }
    }
  },
  watch: {
    elementList (newValue, oldValue) {
      this.elementObjList = this.elementList
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-assessment {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-1Perc {
  padding-top: 1%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-assessment-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-assessment-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-assessment-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-3Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}
.margin-top-2Point5Perc{
  margin-top: 2.5%;
}
.padding-left-2Perc{
  padding-left: 2%; 
}
.padding-left-5Perc{
  padding-left: 5%;
}
.border-red {
  border: 1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/components/assessment_journey/CreateAssessment.vue